/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Keep_In_WorkoutInputs */

const en_us2_draft_keep_in_workout = /** @type {(inputs: Draft_Keep_In_WorkoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep it`)
};

const pt_br2_draft_keep_in_workout = /** @type {(inputs: Draft_Keep_In_WorkoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manter no treino`)
};

const es_419_draft_keep_in_workout = /** @type {(inputs: Draft_Keep_In_WorkoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantenerlo`)
};

const pt_pt2_draft_keep_in_workout = /** @type {(inputs: Draft_Keep_In_WorkoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manter no treino`)
};

const fr_fr2_draft_keep_in_workout = /** @type {(inputs: Draft_Keep_In_WorkoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le garder`)
};

const de_de2_draft_keep_in_workout = /** @type {(inputs: Draft_Keep_In_WorkoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Behalten`)
};

const it_it2_draft_keep_in_workout = /** @type {(inputs: Draft_Keep_In_WorkoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tienilo`)
};

/**
* | output |
* | --- |
* | "Keep it" |
*
* @param {Draft_Keep_In_WorkoutInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const draft_keep_in_workout = /** @type {((inputs?: Draft_Keep_In_WorkoutInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Keep_In_WorkoutInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_draft_keep_in_workout(inputs)
	if (locale === "es-419") return es_419_draft_keep_in_workout(inputs)
	if (locale === "pt-PT") return pt_pt2_draft_keep_in_workout(inputs)
	if (locale === "fr-FR") return fr_fr2_draft_keep_in_workout(inputs)
	if (locale === "de-DE") return de_de2_draft_keep_in_workout(inputs)
	if (locale === "it-IT") return it_it2_draft_keep_in_workout(inputs)
	return en_us2_draft_keep_in_workout(inputs)
});
export { draft_keep_in_workout as "draft.keep_in_workout" }